import { render, staticRenderFns } from "./UploadFilePaycheck.vue?vue&type=template&id=5b2dbda2&scoped=true"
import script from "./UploadFilePaycheck.vue?vue&type=script&lang=js"
export * from "./UploadFilePaycheck.vue?vue&type=script&lang=js"
import style0 from "./UploadFilePaycheck.vue?vue&type=style&index=0&id=5b2dbda2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2dbda2",
  null
  
)

export default component.exports